export default "__VITE_ASSET__Cye$pLaK__"